import DataProtection from "../components/lawandorder/DataProtection.tsx";
import Impressum from "../components/lawandorder/Impressum.tsx";
import Nutzungsbedingung from "../components/lawandorder/Nutzungsbedingung.tsx";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import SEO from "../components/core/SEO.tsx";
import { ROUTE_ABOUT } from "../const/routes.ts";

function About() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;

    const id = hash.replace("#", "");
    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({ behavior: "instant" });
    }
  }, [hash]);
  return (
    <div className="min-h-screen safe-bottom-with-dock safe-top-with-hanger bg-base-200">
      <SEO
        title="Impressum & Datenschutz"
        description="Impressum und Datenschutzerklärung von Surfanzeigen.de – Informationen zum Betreiber und zum Umgang mit deinen Daten"
        url={ROUTE_ABOUT}
        noIndex
      />
      <div className="p-3">
        <section className="mb-8">
          <h2 className="text-xl font-bold">Non-Profit</h2>
          <p className="text-sm opacity-70">
            Ich möchte darauf Aufmerksam machen, dass die Seite ein
            Hobby-Projekt ist und keine Gewinne erzielt. Es werden nur Daten
            erhoben, die für den Betrieb von Surfanzeigen (der Webseite unter
            www.surfanzeigen.de) vor Betrug schützen und die technische
            Umsetzung ermöglichen. Unter der Datenschutzerklärung findest du
            mehr Informationen dazu.
          </p>
        </section>

        <main className="grid gap-6">
          {/*Impressum*/}
          <section className="card bg-base-100 shadow-md" id="impressum">
            <div className="card-body">
              <h2 className="card-title">Impressum</h2>

              <Impressum />
            </div>
          </section>
          <section
            className="card bg-base-100 shadow-md"
            id="datenschutzerklaerung"
          >
            <div className="card-body">
              <h2 className="card-title">Datenschutzerklärung</h2>

              <DataProtection />
            </div>
          </section>
          <section
            className="card bg-base-100 shadow-md"
            id="nutzungsbedingung"
          >
            <div className="card-body">
              <h2 className="card-title">Nutzungsbedingungen</h2>

              <Nutzungsbedingung />
            </div>
          </section>
        </main>
      </div>
    </div>
  );
}

export default About;
